<div>
    <div class = "dialog-header-container">
        <h2 mat-dialog-title class="mar-b-5 pd-t-5px">Delete Meeting</h2>
        <div>            
            <button mat-icon-button mat-dialog-close><mat-icon>close</mat-icon></button>
        </div>
    </div>
    <mat-divider class="mat-divider"></mat-divider>
    <div mat-dialog-content class="dialog-with-actions">
        <div class="row m-0 mt-3">
            <mat-form-field class="body-font-size col-md-12">
                <!-- <input class="row body-font-size" type="text" id="deleteMeetingId" [(ngModel)]="reason"  matInput placeholder="Reason"  name="name" autocomplete="off"  > -->
                <textarea matInput class="row body-font-size" type="text" id="deleteMeetingId" [(ngModel)]="reason"  matInput placeholder="Reason"  name="name" autocomplete="off"></textarea>
            </mat-form-field>
        </div>
    </div>

    <div class="d-flex justify-content-end" mat-dialog-actions>
        <!-- <span><button class="button-container primary" type="button" mat-flat-button color="primary" (click)="deleteMeeting()">Delete</button></span>&nbsp;&nbsp;
        <span> -->
            <button class="button-container primary" type="button" mat-flat-button color="primary" (click)="deleteMeeting()">
                DELETE
            </button>
            <button type="button" #editModalClose mat-flat-button color="primary" class="button-container primary" (click)="closeDialog()">
                CANCEL
            </button>
        <!-- </span> -->
    </div>
</div>